// Function to set padding-top of elements with class 'min-header'
const setHeaderPadding = () => {
    const headerWrapper = document.querySelector('.header-wrapper');
    
    // Ensure headerWrapper exists before trying to get its height
    if (headerWrapper) {
        const headerHeight = headerWrapper.offsetHeight; // Get the height of the header

        // Set the padding-top for all elements with class 'min-header'
        document.querySelectorAll('.min-header').forEach(element => {
            element.style.paddingTop = `${headerHeight}px`;
        });
    }
};

// Run the function when the window is fully loaded
window.addEventListener('load', setHeaderPadding);

// Also run the function when the window is resized
window.addEventListener('resize', setHeaderPadding);